
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/sentry.client.config.ts")
            }
          });